class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    //added for cart drawer
    this.wrapper = document.getElementById('cart-notification-wrapper');
    this.product = document.getElementById('cart-notification-product');

    this.onBodyClick = this.handleBodyClick.bind(this);
    
    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );

    this.massDrawer = document.querySelector("mass-drawer");
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    // console.log("*** PARSED STATE ***");
    // console.log(JSON.stringify(parsedState));
      this.productId = parsedState.id;
      this.getSectionsToRender().forEach((section => {
        // console.log("SECTION ID: " + section.id + " SECTION SELECTOR " + section.selector);
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.querySelector(section.selector) || document.getElementById(section.id);
        // document.getElementById(section.id).innerHTML =(
          // this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        // console.log("ELEMENT TO REPLACE: " + elementToReplace.outerHTML);
        // console.log("REPLACING: " + elementToReplace.innerHTM)
        // console.log("WITH: " + this.getSectionInnerHTML(parsedState.sections[section.id], section.selector));
        console.log(`%c[MassTech / Cart Notification] rendering ${elementToReplace.className}`, "color: chocolate");
        elementToReplace.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);

        if (section.selector.includes('cart-items') || section.selector.includes('cart__items') ) {
          this.massDrawer.resetIds();
        }

        if(section.selector === 'cart-footer') {
          if (this.massDrawer.items.ids.length) {
            document.querySelectorAll(".mass-drawer__quick-footer").forEach(element => element.classList.remove("is-empty"));   }
        }

      }));

      if (this.header) this.header.reveal();
      // this.open();
      this.massDrawer.open();
      this.massDrawer.renderCompleted();
      document.querySelectorAll("cart-footer").forEach((element) => element.findDynamicElements());
      document.querySelectorAll("cart-items").forEach((element) => element.currentItemCount += parsedState.quantity);

     console.log(`%c[MassTech / Cart Notification] render complete`, "color: green");
  }

  getSectionsToRender() {
    const sectionsRender = [
      // {
      //   id: 'cart-notification-product',
      //   //this line below!!
      //   selector: `#cart-notification-product-${this.productId}`,
      // },
      // {
      //   id: document.getElementById('cart-notification-button').dataset.id,
      //   selector: '#cart-notification-button'
      // },
      {
        id: 'mass-drawer',
        selector: '#mass-drawer-progress'
      }
      // {
      //   id: 'cart-icon-bubble'
      // },
      // {
      //   id: document.querySelector('.cart__items').dataset.id,
      //   selector: document.querySelector('cart-items').classList.contains("is-empty") ? 
      //               '.mass-drawer__body' : '.cart-items__js-contents'
      // },
      // {
      //   id: document.querySelector('.cart__footer__top').dataset.id,
      //   selector: document.querySelector('.cart__footer__top').classList.contains("is-empty") ?
      //               'cart-footer' : '.cart-footer__js-contents'
      // }
    ];

    document.querySelectorAll('.cart-icon-bubble').forEach(element => sectionsRender.push({
      id: element.dataset.id,
      selector: `#${element.id}`
    }));
    document.querySelectorAll('.cart__items').forEach(element => sectionsRender.push({
      id: element.dataset.id,
      selector: document.getElementById(element.dataset.id).querySelector('cart-items').classList.contains("is-empty") ?
                  '.cart__items__top' : '.cart-items__js-contents'
    }));
    sectionsRender.push ({
      id: 'mass-drawer',
      selector: '.mass-drawer__suggestions-media'
    });
    document.querySelectorAll('.cart__footer__top').forEach(element => sectionsRender.push({
      id: element.dataset.id,
      selector: element.classList.contains("is-empty") ? element.dataset.selectorEmpty : element.dataset.selector
    }));
    // sectionsRender.push ({
    //   id: 'cart-live-region-text',
    //   section: 'cart-live-region-text',
    //   selector: '.shopify-section'
    // })
    // console.log("*** CART NOTIFICATION SECTION RENDER \n" + JSON.stringify(sectionsRender));
    return sectionsRender;
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
